import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoSearchFilterMode, PoTableColumn} from '@po-ui/ng-components';
import { Transportadora } from 'src/app/interface/transportadora';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { defaultPedidoLote, defaultRomaneioClienteDto, PedidoLote, RomaneioClienteDto, RomaneioClienteItem } from '../../romaneio/interface/romaneio';
import { Veiculo } from '../../romaneio/interface/veiculo';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { VeiculoLookupService } from '../../romaneio/service/veiculo-lookup-service';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-romaneio-cliente-cadastro-expedicao',
  templateUrl: './romaneio-cliente-cadastro-expedicao.component.html',
  styleUrls: ['./romaneio-cliente-cadastro-expedicao.component.css']
})
export class RomaneioClienteCadastroExpedicaoComponent implements OnInit {

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  isProgCarregamento: boolean = false;

  codigoRomaneio: string = '';
  romaneioCliente: RomaneioClienteDto;
  alteraRomaneio: RomaneioClienteDto;

  etiqueta: string = '';
  apareceInformacoes: boolean = false;
  bloqueiaPlaca: boolean = false;

  poNumber: string = '';
  filtroItens: string = '';
  filtroStatus: string = '';

  contadorItem: number = 1;

  pesoRomaneio: number = 0;
  pesoLimite: number = 0;

  permissaoExpedicao: boolean = true;
  permissaoComercial: boolean = true;
  permissaoFaturamento: boolean = true;

  pedidosFiltradosHelp: Array<PedidoLote> = [];
  pedidosFiltrados: Array<PedidoLote> = [];

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  constructor(
    private romaneioService: RomaneioService,
    private route: ActivatedRoute,
    private poDialogService: PoDialogService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    public veiculoLookupService: VeiculoLookupService,
    public transportadoraService: TransportadoraService,
    private authService: AuthService,

  ) {
    this.romaneioCliente = defaultRomaneioClienteDto();
    this.alteraRomaneio = defaultRomaneioClienteDto();

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;

  }

  @ViewChild('alteraDadosModal', { static: true }) alteraDadosModal!: PoModalComponent;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if ('CZ00COD' in params) {
        this.codigoRomaneio = params['CZ00COD'];

        if ('CPROG' in params){
          this.isProgCarregamento = true;
        }

        this.loadDados();

        this.authService.validaPrivilegio(["PO_EXPEDICAO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoExpedicao = ret;
        });

        this.authService.validaPrivilegio(["PO_COMERCIAL", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoComercial = ret;
        });

        this.authService.validaPrivilegio(["PO_FATURAMENTO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
          this.permissaoFaturamento = ret;
        });

      }
    });
  }

  goTo(): void {
    this.router.navigateByUrl('');
  }

  loadDados(): void {
    this.romaneioService.getRomaneioCliente(this.codigoRomaneio).subscribe(romaneio => {
      this.romaneioCliente = romaneio;
      this.alteraRomaneio = romaneio;
      this.romaneioCliente.itemsSelecionados = this.romaneioCliente.itemsSelecionados.map((item) => {
        item.contador = this.contadorItem;
        this.contadorItem += 1;
        return {...item, favorite: ['excluir']};
      })
      this.romaneioCliente.pedidos = this.romaneioCliente.pedidos.map((pedido) => {
        let vinc = 0;
        let contador = 1;
        if (pedido.NEE7PESOLI > this.pesoLimite) {
          this.pesoLimite = pedido.NEE7PESOLI
        }
        pedido.lotes = pedido.lotes.map((lote) => {
          lote.contador = contador;
          lote.status = 'P';
          if (lote.NZ01QUANT == lote.NQTDVINCROMANEIO) {
            lote.status = 'R';
            vinc++;
            this.poNumber = pedido.CEE7PEDIDO;
          } else if (lote.NZ01QUANT == lote.NQTDVINCTOTAL) {
            lote.status = 'V';
            vinc++;
          }
          contador += 1;
          return {...lote};
        });
        pedido.status = 'P';
        if (vinc == pedido.lotes.length) {
          pedido.status = 'T';
        } else if (vinc > 0) {
          pedido.status = 'V';
        }
        return {...pedido};
      });
      this.pedidosFiltradosHelp = this.romaneioCliente.pedidos;
      this.pedidosFiltrados = this.romaneioCliente.pedidos;

      if ((this.romaneioCliente.CZ00STATUS === '3' || this.romaneioCliente.CZ00STATUS === '4') ) {
        this.bloqueiaPlaca = true;
      } else {
        this.bloqueiaPlaca = false;
      }
    }, (e) => {
      this.poDialogService.alert({
        title: 'ATENÇÃO',
        message: 'Romaneio Cliente Inválido.',
        ok: () => this.goTo()
      });
    });
  }

  goToLista(): void {
    if (this.isProgCarregamento){
      this.router.navigateByUrl('/estoque/expedicao/programacao-carregamento-me/lista');
    } else {
      this.router.navigateByUrl('/estoque/expedicao/romaneio-cliente');
    }
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Romaneio Cliente', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Editar Romaneio' }
    ]
  };

  public readonly actions: Array<PoPageAction> = [
    { label: 'Atualizar Status', action: this.modalAtualizarStatusOpen.bind(this), disabled: this.desabilitaAtualizarStatus.bind(this) },
    { label: 'Alterar Dados', action: this.alterarDados.bind(this), disabled: this.desabilitaAlterarDados.bind(this)},
    { label: 'Liberar Pedido', action: this.liberarPedido.bind(this), disabled: this.desabilitaLiberarPedido.bind(this)},
  ];

  public readonly colunasPedidos: Array<PoTableColumn> = [
    {
      property: 'status',
      type: 'label',
      width: '10%',
      labels: [
        { value: 'P', color: 'color-01', label: 'Pendente' },
        { value: 'V', color: 'color-08', label: 'Parc Atendido' },
        { value: 'T', color: 'color-11', label: 'Atendido' },
      ]
    },
    { property: 'CEE7PEDIDO' , visible: true , label: 'Ordem' },
    { property: 'CZ02PEDIDO' , visible: true , label: 'Pedido' },
    { property: 'lotes', label: 'Details', type: 'detail',
      detail: {
        columns: [
          {property: 'contador', label: 'Clas.' },
          {property: 'status', label: 'Status' },
          {property: 'CZ02PEDIDO', label: 'Pedido'},
          {property: 'CZ02LOTE', label: 'Lote'},
          {property: 'CB1COD', label: 'Produto'},
          {property: 'CB1DESC', label: 'Descrição'},
          {property: 'CZ02INFORM', label: 'T ou E'},
          {property: 'CZ02UR', label: 'UR'},
          {property: 'NZ01QUANT', label: 'Qtd Lote'},
          {property: 'NSOMAQTDVEN', label: 'Qtd Pedido'},
          {property: 'NQTDVINCROMANEIO', label: 'Qtd Vinculada Romaneio'},
          {property: 'NQTDVINCTOTAL', label: 'Qtd Vinculada Total'},
          {property: 'NSOMAQTDENT', label: 'Quantidade Entregue'},
          {property: 'NZ02PESO', label: 'Peso'},
          {property: 'CZ02PRAT', label: 'Prateleira'},
          {property: 'CZ02NPACOT', label: 'Pacote'},
          {property: 'NZ02CTNR', label: 'Nro. Container'},
        ],
        typeHeader: 'top'
      }
    }
  ];

  public readonly colunasSelecionados: Array<PoTableColumn> = [
    {property: 'contador', label: 'Clas.'},
    {property: 'CZ02PEDIDO', label: 'Pedido'},
    {property: 'CZ02LOTE', label: 'Lote'},
    {property: 'CB1COD', visible: false, label: 'Produto'},
    {property: 'CB1DESC', label: 'Descrição'},
    {property: 'CZ02INFORM', label: 'T ou E'  , width: '8%', type: 'label',
      labels: [
        { value: 'T', color: 'color-01',  label: 'Toco'     },
        { value: 'E', color: 'color-05',  label: 'Esqui'    },
      ]
    },
    {property: 'CZ02UR', label: 'UR'},
    {property: 'NZ01QUANT', label: 'Quantidade'},
    {property: 'NZ02PESO', label: 'Peso'},
    {property: 'CZ02PRAT', label: 'Prateleira'},
    {property: 'NZ02CTNR', label: 'Nro. Container'},
    {property: 'favorite'  , label: '...'             , width: '10%' ,type: 'icon',
      icons: [
        {
          action: this.openDialogConfirmarExcluirItem.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir',
          value: 'excluir',
          disabled: this.desabilitaExcluir.bind(this)
        }
      ]
    }

  ];

  alterarDados(): void {
    this.alteraRomaneio.DZ00DATA = undefined;
    this.alteraRomaneio.CZ00HORA = '';
    this.alteraDadosModal.open();
  }

  liberarPedido(): void {
    let uniqueValues = [
      ...new Set(this.romaneioCliente.itemsSelecionados.map((element) => element.CZ02PEDIDO)),
    ];
    if (uniqueValues.length > 1) {
      this.poNotificationService.information("Não é possível realizar a liberação via portal, pois os itens do romaneio não pertencem ao mesmo pedido.");
    } else {
      this.router.navigateByUrl(`/estoque/romaneio/liberacao-pedido/CLI/${this.codigoRomaneio}/${this.romaneioCliente.itemsSelecionados[0].CZ02PEDIDO}`);
    }
  }

  public readonly salvarDadosRomaneio: PoModalAction = {
    action: () => {
      this.romaneioService.alterarDadosRomaneioCliente(this.alteraRomaneio).subscribe((ret) => {
        this.alteraDadosModal.close();
        this.loadDados();
      })
    },
    label: 'Salvar',
  };

  modalAtualizarStatusOpen(): void {
    let cvalorTotal = '';
    let cTxtMsg = 'Deseja realmente faturar o Romaneio Cliente?';

    if (this.romaneioCliente.CZ00STATUS == "2") {
      this.romaneioService.valorTotalRomaneio(this.romaneioCliente.itemsSelecionados[0].CZ02PEDIDO).subscribe((ret) => {
        cvalorTotal = ret.CTOTROMANEIO;
        if (cvalorTotal != '0,0' ) {
          cTxtMsg = `O Valor aproximado da NF será de R$ ${cvalorTotal}. Deseja realmente faturar o Romaneio Cliente?`
        }
        this.poDialogService.confirm({
          title: 'Faturar',
          message: cTxtMsg,
          confirm: () => this.atualizarStatus()
        });
      })
    } else {
      this.atualizarStatus()
    }
  }

  desabilitaAtualizarStatus(): boolean {
    let lret = true;

    if (this.romaneioCliente.CZ00STATUS == "0" && this.permissaoExpedicao ) {
      lret = false;
    } else if (this.romaneioCliente.CZ00STATUS == "1" && this.permissaoComercial ) {
      lret = false;
    }
    else if ((this.romaneioCliente.CZ00STATUS == "2" || this.romaneioCliente.CZ00STATUS == "3"|| this.romaneioCliente.CZ00STATUS == "5"|| this.romaneioCliente.CZ00STATUS == "6" ) && this.permissaoFaturamento ) {
      lret = false;
    }

    return lret;
  }

  desabilitaAlterarDados(): boolean {
    return this.romaneioCliente.CZ00STATUS == "Z"
  }

  desabilitaLiberarPedido(): boolean {
    return this.romaneioCliente.CZ00STATUS != "1" || !this.permissaoComercial || this.romaneioCliente.itemsSelecionados.length == 0;
  }

  getPdfRomaneio(): void {
    this.romaneioService.getPdfRomaneio(this.romaneioCliente.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${this.romaneioCliente.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  atualizarStatus(): void {
    this.romaneioService.atualizarStatusRomaneioCliente(this.romaneioCliente).subscribe(() => {
      this.poNotificationService.success("Status atualizado com sucesso!");
      if (this.romaneioCliente.CZ00STATUS == "2") {
        this.getPdfRomaneio();
      }
      this.loadDados();
    });
  }

  selectLinha(row: PedidoLote): void {
    //@ts-ignore
   if (row.lotes?.length) {
      for (const item of row.lotes){
        //@ts-ignore
        item.$selected = row.$selected;
      }
    }
  }

  adicionarItensRomaneio(): void {
    let pedidoLote: PedidoLote = defaultPedidoLote();
    for (const item of this.pedidosFiltrados) {
      for (const lote of item.lotes) {
        //@ts-ignore
        if (lote.$selected) {
          if (lote.status == 'P') {
            pedidoLote.lotes.push(lote);
          }
        }
      }
    }

    this.romaneioService.adicionarItensRomaneioCliente(this.romaneioCliente.CZ00COD, pedidoLote).subscribe(() => {
      for (const item of this.pedidosFiltrados) {
        let cont = 0;
        for (const lote of item.lotes) {
          //@ts-ignore
          if (lote.$selected) {
            if (this.poNumber == '' || this.poNumber == item.CEE7PEDIDO) {
              this.poNumber = item.CEE7PEDIDO;
              if (lote.status == 'P') {
                this.romaneioCliente.itemsSelecionados.push(lote);
                lote.contador = this.contadorItem;
                this.contadorItem += 1;
                lote.status = 'R';
                lote.NQTDVINCROMANEIO = lote.NZ01QUANT;
                lote.NQTDVINCTOTAL = lote.NZ01QUANT;
              }
            } else {
              this.romaneioService.removerEtiqueta(this.codigoRomaneio, lote.CZ02LOTE).subscribe((e) => {
                this.poNotificationService.error(`Não foi possível adicionar o lote ${lote.CZ02LOTE}, pois este Romaneio já possui itens com outro P.O. Number.`);
              })
            }
          }
          if (lote.status == 'R' || lote.status == 'V') {
            item.status = 'V';
            cont++;
          }
        }
        if (cont == item.lotes.length) {
          item.status = 'T';
        }
      }
    });
  }

  validaAddRomaneio(): void {
    let pedidoLote: PedidoLote = defaultPedidoLote();
    let cpedidoSelecionado =  '', string;
    let lcontinua =  true, Boolean;

    this.pesoRomaneio = 0
    this.romaneioCliente.itemsSelecionados.map(item => {
      this.pesoRomaneio += item.NZ02PESO
    });

    for (const item of this.pedidosFiltrados) {
      for (const lote of item.lotes) {
        //@ts-ignore
        if (lote.$selected) {
          if (lote.status == 'P'){
            this.pesoRomaneio += lote.NZ02PESO
          }
          if (lote.status == 'P' && cpedidoSelecionado.length > 0  && cpedidoSelecionado != lote.CZ02PEDIDO) {
            lcontinua = false;
          } else {
            cpedidoSelecionado = lote.CZ02PEDIDO
          }
        }
      }
    }
    if (lcontinua) {
      if (this.pesoLimite > 0 && this.pesoRomaneio > this.pesoLimite) {
          this.poNotificationService.error(`Peso do Romaneio: ${this.pesoRomaneio} Maior que o Peso Limite: ${this.pesoLimite}`);}
          else {
          this.adicionarItensRomaneio()
        }
    }
    else {
      this.poNotificationService.error('Não é possível adicionar lotes de diferentes pedidos.');
    }
  }

  clickInformacoes(): void {
    this.apareceInformacoes = !this.apareceInformacoes;
  }

  openDialogConfirmarExcluirItem(row: RomaneioClienteItem): void {
    this.poDialogService.confirm({
      title: 'Excluir Item',
      message: 'Deseja realmente excluir o item?',
      confirm: () => this.excluirItem(row)
    });
  }

  excluirItem(row: RomaneioClienteItem): void {
    this.romaneioService.removerEtiqueta(this.codigoRomaneio,row.CZ02LOTE).subscribe( () => {
      this.loadDados();
    });
  }

  desabilitaExcluir(row: RomaneioClienteItem): boolean {
    return this.romaneioCliente.CZ00STATUS == 'Z' || !this.permissaoExpedicao;
  }

  filtrarPedidos(): void {
    this.pedidosFiltradosHelp = this.romaneioCliente.pedidos;

    if (this.filtroItens != '') {
      for (let i=0; i < this.pedidosFiltradosHelp.length; i++) {
        this.pedidosFiltradosHelp[i].lotes = this.pedidosFiltradosHelp[i].lotes.filter((lote) => {
          return lote.CZ02PEDIDO.includes(this.filtroItens) ||
          this.pedidosFiltradosHelp[i].CEE7PEDIDO.includes(this.filtroItens) ||
          lote.CZ02LOTE.includes(this.filtroItens) ||
          lote.CB1COD.includes(this.filtroItens) ||
          lote.CB1DESC.includes(this.filtroItens) ||
          lote.CZ02PRAT.includes(this.filtroItens) ||
          lote.CZ02UR.includes(this.filtroItens)
        });
      }

      this.pedidosFiltrados = this.pedidosFiltradosHelp.filter((item) => {
        return item.lotes.length > 0;
      });
    } else {
      this.pedidosFiltrados = this.romaneioCliente.pedidos;
    }

    if (this.filtroStatus == 'NV') {
      for (let i=0; i < this.pedidosFiltradosHelp.length; i++) {
        this.pedidosFiltradosHelp[i].lotes = this.pedidosFiltradosHelp[i].lotes.filter((lote) => {
          return lote.status != 'V';
        });
      }

      this.pedidosFiltrados = this.pedidosFiltradosHelp.filter((item) => {
        return item.lotes.length > 0;
      });
    }
  }

}
